<template>
  <div class="home-banner-wrap">
    <div class="home-banner-swiper-container swiper-container-outer" id="homeBannerId">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(item, index) in list" :key="index">
          <div class="slide-content" :style="{'background-image':`url(${projectFileUrl}/${item.imgUrl})`}">
            <!-- <el-image :src="item.image" fit="contain"></el-image> -->
          </div>
        </swiper-slide>
      </swiper>
      <!-- 分页 -->
      <div class="swiper-pagination my-swiper-pagination swp-page1"></div>
      <!-- 左按钮 -->
      <div class="swiper-button-prev my-swiper-button swp1"></div>
      <!-- 右按钮 -->
      <div class="swiper-button-next my-swiper-button swp1"></div>
    </div>
  </div>
</template>

<script>
import SwiperCore, { Navigation, Pagination } from "swiper";
// Import Swiper styles
import "swiper/swiper.less";
import "swiper/components/navigation/navigation.less";
import "swiper/components/pagination/pagination.less";
// install Swiper modules
SwiperCore.use([Navigation, Pagination]);

const swiperDelay = 5000; // 切换swiper 

export default {
  data() {
    return {
      swiperOptions: {
        loop: true,
        autoplay: false,
        slidesPerView: "auto", //显示个数
        touchStartPreventDefault: false, // 不阻止事件
        observer: true,
        observerParents: true,
        pagination: {
          el: ".swiper-pagination.swp-page1",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next.swp1",
          prevEl: ".swiper-button-prev.swp1",
        },
      },
      mobileWidth: false
    }
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  components: {

  },
  mounted() {
    this.setVisibleNumber();
  },
  methods: {
    setVisibleNumber() {
      const width = document.body.getBoundingClientRect().width;
      this.mobileWidth = parseInt(width) <= 768;
    },
  },
  beforeMount() {
    window.addEventListener('resize', this.setVisibleNumber)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setVisibleNumber)
  },
}
</script>

<style lang="less" scoped>
.home-banner-wrap {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 37.5%;
  .home-banner-swiper-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}
.swiper-container-outer {
  width: 100%;
  height: 100%;
  position: relative;
  .slide-content {
    width: 100%;
    height: 100%;
    position: relative;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    .el-image {
      width: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .my-swiper-pagination {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    /deep/ .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      border-radius: 100%;
      margin: 0 6px;
      background: #fff;
    }
  }
  .my-swiper-button {
    // width: 30px;
    background: transparent;
    color: #fff;
    border-radius: 2px;
    &.swiper-button-prev {
      left: 20px;
    }
    &.swiper-button-next {
      right: 20px;
    }
    &::after {
      font-size: 42px;
      font-weight: bold;
    }
  }
  .swiper-container {
    width: 100%;
    height: 100%;
    .swiper-slide {
      color: #fff;
      > div {
        height: 100%;
      }
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1280px) {
  .home-banner-wrap {
    padding-bottom: 44%;
  }
}

@media screen and (max-width: 768px) {
  .home-banner-wrap {
    padding-bottom: 60%;
  }

  .swiper-container-outer {
    .my-swiper-pagination {
      bottom: 14px;
      /deep/ .swiper-pagination-bullet {
        width: 6px;
        height: 6px;
        border-radius: 100%;
      }
    }
    .my-swiper-button {
      &.swiper-button-prev {
        left: 14px;
      }
      &.swiper-button-next {
        right: 14px;
      }
      &::after {
        font-size: 22px;
      }
    }
    .swiper-container {
      width: 100%;
      height: 100%;
      .swiper-slide {
        color: #fff;
        > div {
          height: 100%;
        }
      }
    }
  }
}
</style>